import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
@Component({
  selector: 'c4dweb-checkbox',
  template: `
    <ng-container *ngIf="group != null">
      <div
        class="property-checkbox"
        [class.field-disabled]="field?.disabled"
        [formGroup]="group"
      >
        <mat-checkbox
          [formControlName]="field.name"
          [indeterminate]="field.mixed && group?.get(field.name)?.value == null"
          (change)="changeValue(field.name, $event)"
          >{{ field.label.toUpperCase() }}</mat-checkbox
        >
      </div>
    </ng-container>

    <ng-container *ngIf="group == null">
      <div class="property-checkbox" [class.field-disabled]="field?.disabled">
        <mat-checkbox>{{ field.label }}</mat-checkbox>
      </div>
    </ng-container>
  `,
  styleUrls: ['./c4dweb-checkbox.component.scss'],
})
export class C4dWebCheckboxComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  @Output() eventChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}
  ngOnInit(): void {}

  changeValue(id, $event): void {
    let strValue = '';
    if (this.group != null) {
      strValue = this.group?.get(id)?.value;
    } else {
      strValue = $event;
    }
    const ret = {
      fieldId: id,
      value: strValue,
    };
    console.log('date change', ret);
    this.eventChange.emit(ret);
  }
}
